import { qualityGuideUrl } from '@/lib/guide-links.js';

const GENERATION_GUIDES = {
  plan: {
    slug: 'generate-test-cases',
    section: 'choose-sources-and-output',
    label: 'Generation guide',
  },
  context: {
    slug: 'prepare-test-generation-sources',
    section: 'routes',
    label: 'Source guide',
  },
  skills: {
    slug: 'generate-test-cases',
    section: 'write-a-useful-prompt',
    label: 'Drafting guide',
  },
  scope: {
    slug: 'generate-test-cases',
    section: 'source-controls',
    label: 'Scope guide',
  },
  explore: {
    slug: 'generate-test-cases',
    section: 'source-controls',
    label: 'Explore guide',
  },
  knowledge: {
    slug: 'knowledge-to-test-cases',
    section: 'search',
    label: 'Knowledge guide',
  },
} as const;
export type GenerationGuideTopic = keyof typeof GENERATION_GUIDES;

/** Existing published articles, with a section chosen for the control that links to them. */
export function generationGuideLink(topic: GenerationGuideTopic) {
  const entry = GENERATION_GUIDES[topic];
  return {
    label: entry.label,
    href: qualityGuideUrl(entry.slug, entry.section),
  };
}
